import { ArticleAuthor } from "./article-author.model";

export class UserContribution {

	public author: ArticleAuthor;

	public articlesCount: number;

}
